import { render, staticRenderFns } from "./InputOptions.vue?vue&type=template&id=0a0c963f"
import script from "./InputOptions.vue?vue&type=script&lang=js"
export * from "./InputOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports